import type { FaireProductEntity } from "../../entity_types/product";

export const p_avhrk6rvjp: FaireProductEntity = {
  token: "p_avhrk6rvjp",
  type: "product",
  name: "Salt and Sea 9 oz Soy Candle - Home Decor & Gifts",
  brandName: "Sweet Water Decor",
  imageUrl:
    "https://cdn.faire.com/fastly/6134e43d77cde53731e269acc3b68f370743bcc03915828a0af1fc73fc551daf.png",
  priceDollars: 12,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/86db89168d4ea94f75c95f3f49342b7232271b5dc15cfe6477ec7a76b0012bad.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
